<div class="container-fluid">
  <app-page-header
    icon="fe-alert-triangle"
    pretitle="Registo"
    title="Ocorrências"
    description="Participações, não conformidades e oportunidades de melhoria — dos sistemas de gestão, do RGPD, do canal de denúncias e da segurança da informação."
  >
    <div actions>
      <a class="btn btn-outline-light me-2" routerLink="../estatisticas">
        <i class="fe fe-bar-chart-2 me-1"></i> Estatísticas
      </a>
      @if (auth.can('occurrence:write')) {
        <a class="btn btn-white" routerLink="nova" queryParamsHandling="preserve">
          <i class="fe fe-plus me-1"></i> Nova ocorrência
        </a>
      }
    </div>
  </app-page-header>
</div>

<div class="container-fluid">
  <!-- Busca + filtros. Em telas pequenas os filtros ficam recolhidos: cinco selects empurravam
       a lista para fora do primeiro ecrã. -->
  <div class="card">
    <div class="card-body">
      <div class="row g-3">
        <div class="col-12">
          <label class="form-label small text-muted">Procurar</label>
          <div class="d-flex gap-2">
            <input
              class="form-control"
              [(ngModel)]="q"
              (ngModelChange)="onSearch()"
              placeholder="Código, título ou descrição"
            />
            <button class="btn btn-white d-md-none text-nowrap" type="button" (click)="toggleFilters()">
              <i class="fe fe-sliders me-1"></i>{{ filtersOpen() ? 'Fechar' : 'Filtros' }}
            </button>
          </div>
        </div>
      </div>
      <div class="row g-3 mt-0 d-md-flex" [class.d-none]="!filtersOpen()">
        <div class="col-6 col-md">
          <label class="form-label small text-muted">Ano</label>
          <select class="form-select" [(ngModel)]="year" (ngModelChange)="load()">
            <option [ngValue]="null">Todos</option>
            @for (option of years; track option) { <option [ngValue]="option">{{ option }}</option> }
          </select>
        </div>
        <div class="col-6 col-md">
          <label class="form-label small text-muted">Situação</label>
          <select class="form-select" [(ngModel)]="situation" (ngModelChange)="load()" data-no-filter>
            <option [ngValue]="null">Todas</option>
            @for (option of situationOptions; track option.value) { <option [ngValue]="option.value">{{ option.label }}</option> }
          </select>
        </div>
        <div class="col-6 col-md">
          <label class="form-label small text-muted">Estado</label>
          <select class="form-select" [(ngModel)]="state" (ngModelChange)="load()">
            <option [ngValue]="null">Todos</option>
            @for (option of stateOptions; track option.value) { <option [ngValue]="option.value">{{ option.label }}</option> }
          </select>
        </div>
        <div class="col-6 col-md">
          <label class="form-label small text-muted">Âmbito</label>
          <select class="form-select" [(ngModel)]="scope" (ngModelChange)="onScopeChange()">
            <option [ngValue]="null">Todos</option>
            @for (option of scopeOptions; track option.value) { <option [ngValue]="option.value">{{ option.label }}</option> }
          </select>
        </div>
        <div class="col-6 col-md">
          <label class="form-label small text-muted">Tipo</label>
          <select class="form-select" [(ngModel)]="type" (ngModelChange)="load()">
            <option [ngValue]="null">Todos</option>
            @for (option of typeOptions(); track option.value) {
              <option [ngValue]="option.value">{{ option.label }}</option>
            }
          </select>
        </div>
        <div class="col-6 col-md">
          <label class="form-label small text-muted">Origem</label>
          <select class="form-select" [(ngModel)]="origin" (ngModelChange)="load()">
            <option [ngValue]="null">Todas</option>
            @for (option of originOptions; track option.value) { <option [ngValue]="option.value">{{ option.label }}</option> }
          </select>
        </div>
        <div class="col-6 col-md">
          <label class="form-label small text-muted">Verificação da eficácia</label>
          <select class="form-select" [(ngModel)]="efficacy" (ngModelChange)="load()">
            <option [ngValue]="null">Todas</option>
            <option value="aplicavel">Aplicável</option>
            <option value="nao-aplicavel">Não aplicável</option>
          </select>
        </div>
        <!-- Aqui, ao lado dos filtros, onde está quem os pôs. O que havia era no cabeçalho dos
             resultados, longe da vista de quem acabou de filtrar. -->
        @if (filtered()) {
          <div class="col-12 col-md-auto d-flex align-items-end">
            <button class="btn btn-sm btn-outline-secondary text-nowrap" (click)="clearFilters()">
              <i class="fe fe-x me-1"></i>Limpar filtros
            </button>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Tabela -->
  <div class="card">
    @if (!loading() && !error() && total() > 0) {
      <div class="card-header">
        <h4 class="card-header-title">
          {{ total() }} {{ total() === 1 ? 'ocorrência' : 'ocorrências' }}
          @if (filtered()) { <span class="text-muted fw-normal">com estes filtros</span> }
        </h4>
        @if (filtered()) {
          <!-- Era um link cinzento no canto e passava despercebido a quem acabou de filtrar. Com
               contorno lê-se como botão, que é o que é. -->
          <button class="btn btn-sm btn-outline-secondary" (click)="clearFilters()">
            <i class="fe fe-x me-1"></i>Limpar filtros
          </button>
        }
      </div>
    }
    <div class="card-body p-0">
      @if (error()) { <p class="text-danger text-center py-5 mb-0">{{ error() }}</p> }
      @else if (loading()) { <p class="text-muted text-center py-5 mb-0">A carregar…</p> }
      @else if (total() === 0) {
        <!-- Estado vazio com saída: filtro apertado demais vs. empresa ainda sem registos -->
        <div class="text-center py-6 px-4">
          <span class="avatar avatar-lg mb-3">
            <span class="avatar-title fs-1 rounded bg-warning-soft text-warning"><i class="fe fe-alert-triangle"></i></span>
          </span>
          @if (filtered()) {
            <h4 class="mb-1">Nenhuma ocorrência com estes filtros</h4>
            <p class="text-muted small mb-3">Experimente alargar o ano ou limpar a busca.</p>
            <button class="btn btn-sm btn-outline-secondary" (click)="clearFilters()">Limpar filtros</button>
          } @else {
            <h4 class="mb-1">Ainda não há ocorrências registadas</h4>
            <p class="text-muted small mb-3">
              Registe a primeira ou receba participações pelo portal público da empresa.
            </p>
            @if (auth.can('occurrence:write')) {
              <a class="btn btn-sm btn-primary me-2" routerLink="nova" queryParamsHandling="preserve">
                <i class="fe fe-plus me-1"></i>Registar a primeira ocorrência
              </a>
            }
            <a class="btn btn-sm btn-outline-secondary" routerLink="../configuracoes/portal">Ver o portal público</a>
          }
        </div>
      } @else {
        <!-- Registro de qualidade: tile QUADRADO âmbar (não conformidade) -->
        <div class="list-group list-group-flush">
          @for (item of occurrences(); track item.id) {
            <div class="list-group-item occ-row" style="cursor: pointer;" [style.borderLeft]="'4px solid ' + stateColor(item)">
              <div class="row align-items-center">
                <div class="col-auto">
                  <span class="avatar avatar-sm">
                    <span
                      class="avatar-title fs-lg rounded"
                      [class.bg-warning-soft]="!sensitive(item)"
                      [class.text-warning]="!sensitive(item)"
                      [class.bg-danger-soft]="sensitive(item)"
                      [class.text-danger]="sensitive(item)"
                    ><i class="fe" [class]="item.nature ? natureIcons[item.nature] : typeIcons[item.type]"></i></span>
                  </span>
                </div>
                <div class="col ms-n2">
                  <h4 class="mb-1">
                    <!-- Link verdadeiro (stretched-link cobre a linha): ctrl/⌘+clique e o clique do meio
                         abrem noutro separador, e o teclado chega lá sem tabindex. -->
                    <a class="stretched-link text-reset text-decoration-none" [routerLink]="[item.id]">{{ item.title }}</a>
                    @if (sensitive(item)) {
                      <span class="badge bg-danger-soft ms-1" title="Tratamento reservado — circuito confidencial">
                        <i class="fe fe-lock me-1"></i>Confidencial
                      </span>
                    }
                    @if (item.participantIdentification === 'ANONIMO') {
                      <span class="badge bg-secondary-soft ms-1"><i class="fe fe-eye-off me-1"></i>Anónima</span>
                    }
                    <!-- Ligações à vista na lista, e de que lado: "aparecer a indicação se a OC
                         é a mãe ou a filha" (documento de 2026-10-08). -->
                    @if (item.parentId) {
                      <span class="badge bg-info-soft ms-1" title="Nasceu de outra ocorrência">
                        <i class="fe fe-link me-1"></i>Filha
                      </span>
                    }
                    @if (item.hasChildren) {
                      <span class="badge bg-info-soft ms-1" title="Deu origem a outras ocorrências">
                        <i class="fe fe-link me-1"></i>Mãe
                      </span>
                    }
                  </h4>
                  <p class="card-text small text-muted mb-0">
                    <span class="badge bg-secondary-soft me-1">{{ item.code }}</span>
                    {{ scopeLabels[item.scope] }} <span class="mx-1">·</span>
                    @if (item.nature) {
                      {{ natureLabels[item.nature] }}
                    } @else {
                      {{ typeLabels[item.type] }}
                    }
                    <span class="mx-1">·</span> {{ originLabels[item.origin] }}
                    <span class="mx-1">·</span>
                    @if (efficacyApplicable(item)) {
                      <span class="badge bg-success-soft">Eficácia aplicável</span>
                    } @else {
                      <span class="badge bg-secondary-soft opacity-75">Eficácia não aplicável</span>
                    }
                  </p>
                </div>
                <!-- Três datas, que respondem a perguntas diferentes: quando aconteceu, até
                     quando há para agir, e quando foi mexida pela última vez. A última era a que
                     faltava — a lista mostrava o prazo ou a data de fecho no mesmo sítio, e não
                     se via desde quando um caso estava parado. -->
                <div class="col-auto d-none d-lg-block text-end occ-row-date">
                  <span class="small text-muted d-block">Data da ocorrência</span>
                  <span class="small fw-bold">{{ item.occurrenceDate | date: 'dd/MM/yyyy' }}</span>
                </div>
                <div class="col-auto d-none d-md-block text-end occ-row-date">
                  @if (item.situation === 'FECHADO') {
                    <span class="small text-muted d-block">Fechada</span>
                    <span class="small fw-bold">{{ item.closingDate | date: 'dd/MM/yyyy' }}</span>
                  } @else {
                    <!-- Enquanto está só registada o prazo ainda é provisório: foi calculado
                         antes de alguém olhar para o caso. -->
                    <span class="small text-muted d-block">
                      Prazo de implementação @if (item.state === 'REGISTADO') { <span class="text-muted">(provisório)</span> }
                    </span>
                    <span class="small fw-bold" [class.text-warning]="item.deadlineApproaching">
                      @if (item.actionImplementationDeadline) {
                        @if (item.deadlineApproaching) { <i class="fe fe-alert-triangle me-1"></i> }
                        {{ item.actionImplementationDeadline | date: 'dd/MM/yyyy' }}
                      } @else {
                        <span class="text-muted fw-normal">—</span>
                      }
                    </span>
                  }
                </div>
                <div class="col-auto d-none d-lg-block text-end occ-row-date">
                  <span class="small text-muted d-block">Alteração de estado</span>
                  <!-- `stateChangedAt` já cobre o fecho: o servidor marca-o sempre que o estado
                       ou a situação mudam. Repetir aqui a data de fecho era dizer duas vezes a
                       mesma coisa na mesma linha.

                       Quem nunca saiu de Registado não tem alteração nenhuma, e a coluna ficava
                       com um traço — mas a pergunta ("desde quando está assim?") tem resposta: é
                       o dia em que deu entrada. -->
                  <span class="small fw-bold">
                    {{ (item.stateChangedAt ?? item.createdAt) | date: 'dd/MM/yyyy' }}
                  </span>
                </div>
                <!-- No telemóvel o estado e os botões descem para uma linha própria: ao lado do título
                     deixavam-lhe uma coluna de três palavras por linha. -->
                <div class="col-6 col-sm-auto mt-2 mt-sm-0">
                  <span class="badge" [class]="badgeClass(item)">{{ stateBadgeLabel(item) }}</span>
                </div>
                <!-- Editar e eliminar sem entrar na ocorrência (documento de 2026-10-08). O
                     clique pára aqui: a linha inteira é um link para a ficha. -->
                @if (auth.can('occurrence:write') || auth.can('occurrence:delete')) {
                  <div class="col-6 col-sm-auto text-end text-sm-start mt-2 mt-sm-0 occ-row-actions">
                    @if (auth.can('occurrence:write')) {
                      <!-- O "?origem=lista" é o que faz o Cancelar voltar aqui, e não à ficha
                           (revisão de 2026-10-19). -->
                      <a class="btn btn-sm btn-white me-1" [routerLink]="[item.id, 'editar']"
                         [queryParams]="{ origem: 'lista' }"
                         (click)="stop($event)" title="Editar">
                        <i class="fe fe-edit-2"></i>
                      </a>
                    }
                    @if (auth.can('occurrence:delete')) {
                      <button type="button" class="btn btn-sm btn-white"
                              (click)="askRemove(item, $event)" title="Eliminação total">
                        <i class="fe fe-trash-2"></i>
                      </button>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
    @if (total() > pageSize) {
      <app-pagination
        [total]="total()"
        [page]="page()"
        [pageSize]="pageSize"
        (pageChange)="onPage($event)"
      />
    }
  </div>
</div>

<!-- Painel de registo: rota filha, para a lista ficar montada por trás. -->
<router-outlet />

<!-- Dois passos quando há ocorrências criadas a partir desta, e dá para voltar atrás no segundo:
     nada se elimina antes de tudo respondido (revisão de 2026-10-15). -->
@if (pendingRemoval(); as pending) {
  @if (removalStep() === 'confirmar') {
    <!-- Texto da revisão de 2026-10-19, tal como veio. -->
    <app-confirm-dialog
      title="Eliminação definitiva da ocorrência"
      [message]="'Esta ação elimina permanentemente a ocorrência ' + pending.code + ' e todos os registos associados, incluindo análise, ações de tratamento, seguimentos, evidências, anexos e comunicações.

'
        + 'Esta ação é irreversível.'
        + (pending.hasChildren ? ' As ocorrências criadas a partir desta não serão eliminadas, mas perderão a ligação à ocorrência original.' : '')
        + '

Tem a certeza de que pretende continuar?'"
      [confirmLabel]="pending.hasChildren ? 'Continuar' : 'Eliminar'"
      [danger]="true"
      (confirm)="confirmRemove()"
      (cancel)="cancelRemove()"
    />
  } @else {
    <div class="modal d-block" tabindex="-1" role="dialog" style="background: rgba(0,0,0,.5);">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Ocorrências criadas a partir de {{ pending.code }}</h5>
          </div>
          <!-- Só nas mães: uma filha sem filhas não chega a este passo (revisão de 2026-10-19). -->
          <div class="modal-body">
            <p class="mb-2">Foram identificadas as seguintes ocorrências criadas a partir desta ocorrência:</p>
            <ul class="mb-3 ps-3">
              @for (child of pendingChildren(); track child.id) {
                <li><strong>{{ child.code }}</strong> — {{ child.title }}</li>
              } @empty {
                <li class="text-muted">A carregar…</li>
              }
            </ul>
            <p class="mb-2">
              Pretende manter estas ocorrências, removendo a ligação à ocorrência original, ou
              eliminá-las também?
            </p>
            <p class="small text-muted mb-0">
              Nota: As ocorrências mantidas conservarão o seu histórico, deixando apenas de estar
              associadas à ocorrência eliminada.
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-white" (click)="backToConfirm()">Voltar</button>
            <button type="button" class="btn btn-white" (click)="removeKeepingChildren()">Manter, sem ligação</button>
            <button type="button" class="btn btn-danger" (click)="removeWithChildren()">Eliminar também</button>
          </div>
        </div>
      </div>
    </div>
  }
}
